import { render, staticRenderFns } from "./MensagemDaConversaAtiva.vue?vue&type=template&id=54d94c31&"
import script from "./MensagemDaConversaAtiva.vue?vue&type=script&lang=js&"
export * from "./MensagemDaConversaAtiva.vue?vue&type=script&lang=js&"
import style0 from "./MensagemDaConversaAtiva.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports